
    <div
      *ngIf="! standalone"
      class="form-group"
    >
      <div class="d-flex d-flex-gap w-100">
        <fieldmagic-text
          *ngIf="label | filled"
          purpose="input"
          [content]="label"
          [withRequiredMarker]="withRequiredMarker"
        >
        </fieldmagic-text>

        <fieldmagic-icon
          *ngIf="tooltip | filled"
          icon="info-circle"
          [tooltip]="tooltip"
        >
        </fieldmagic-icon>
      </div>

      <ng-container *ngTemplateOutlet="input"></ng-container>
    </div>

    <ng-container
      *ngIf="standalone"
      [ngTemplateOutlet]="input"
    >
    </ng-container>

    <ng-template #input>
      <div class="d-flex d-flex-gap w-100">
        <input
          [disabled]="(disabled$ | async) || unit == 'always'"
          type="number"
          [(ngModel)]="size"
          class="w-50 form-control fieldmagic-interval-size-input"
          (ngModelChange)="onInputsChanged()"
          [class.fieldmagic-input-has-error]="errors | filled"
          (blur)="onInputsTouched()"
          placeholder="Enter frequency (e.g., 5)"
        />

        <ng-select
          [disabled]="disabled$ | async"
          [items]="units$ | async"
          [(ngModel)]="unit"
          (ngModelChange)="onInputsChanged()"
          class="w-50 fieldmagic-interval-unit-input"
          [class.fieldmagic-input-has-error]="errors | filled"
          (blur)="onInputsTouched()"
          placeholder="Choose time unit"
          [clearable]="clearable"
        >
          <ng-template
            ng-option-tmp
            let-item="item"
          >
            {{ item | translate }}
          </ng-template>

          <ng-template
            ng-label-tmp
            let-item="item"
          >
            {{ item | translate }}
          </ng-template>
        </ng-select>
      </div>

      <fieldmagic-input-errors
        *ngIf="errors | filled"
        [errors]="errors"
      ></fieldmagic-input-errors>
    </ng-template>
  